export const unstyledAttr = {
  firstChild: 'data-first-child',
  lastChild: 'data-last-child',
};
